import { useState } from "react";
import { Link } from "react-router-dom";
import config from "../config";
export default function Header({ routes }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };
  return (
    <header>
      <nav className="headerBlock " id="header">
        <div className="headerLogo">
          <Link to="/">
            <img src="img/logo.png" alt="logo" />
          </Link>
        </div>
        <ul className={`headerMenu ${isOpen ? "header-menu--open" : ""}`}>
          {routes.map((r, i) => (
            <li key={i}>
              <Link to={r.path} onClick={closeMenu}>
                {r.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="headerButton">
          <div>
            <a href={config.partnerLink} rel="nofollow" className="main-button">
              Login
            </a>
            <a
              href={config.partnerLink}
              rel="nofollow"
              className="main-button mainSubBtn"
            >
              Register
            </a>
          </div>
        </div>
      </nav>
      <span
        className={`header-toggler ${isOpen ? "header-toggler--open" : ""}`}
        onClick={toggleMenu}
      ></span>
    </header>
  );
}
